import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { ajax_wrapper } from 'functions';
import { Link } from 'react-router-dom'; // For linking to detail page

const getAuthorDisplayName = (email) => { // Copied from ArticleAdminFormPage and adapted
    if (!email) return '';
    switch (email) {
        case 'andrew@yourhomebase.co':
            return 'Andrew Li';
        case 'ian@yourhomebase.co':
            return 'Ian Tan';
        case 'jeremy@yourhomebase.co':
            return 'Jeremy Thiesen';
        case 'dmiller89@gmail.com':
            return 'Dave Miller'; // As per user's update
        default:
            const namePart = email.split('@')[0];
            if (namePart) {
                return namePart.charAt(0).toUpperCase() + namePart.slice(1);
            }
            return email;
    }
};

// A simple component to display a single blog post item
class BlogListItem extends Component {
    render() {
        const { article } = this.props;
        // console.log('Article object in BlogListItem:', article); // Removed log

        // Use seo_meta_description for the excerpt, fallback to content, then empty string
        let excerptContent = article.seo_meta_description || article.content || '';

        // Simple excerpt: first 150 characters.
        let excerpt;
        if (excerptContent.length > 150) {
            const truncated = excerptContent.substring(0, 150);
            const lastSpace = truncated.lastIndexOf(' ');
            excerpt = (lastSpace > 0 ? truncated.substring(0, lastSpace) : truncated) + "...";
        } else {
            excerpt = excerptContent;
        }

        const articleStyle = {
            border: '1px solid #eee',
            padding: '15px',
            marginBottom: '20px',
            borderRadius: '5px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
        };

        const titleStyle = {
            fontSize: '1.5em',
            marginBottom: '10px'
        };

        const metaStyle = {
            fontSize: '0.9em',
            color: '#666',
            marginBottom: '10px'
        };

        const imageStyle = {
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '5px',
            marginBottom: '10px'
        };
        
        const readMoreStyle = {
            textDecoration: 'none',
            color: '#007bff',
            fontWeight: 'bold'
        };

        return (
            <div style={articleStyle}>
                {article.featured_image && (
                    <img src={article.featured_image} alt={article.title} style={imageStyle} />
                )}
                <h2 style={titleStyle}>
                    <Link to={`/blog/${article.slug}`} style={{textDecoration: 'none', color: 'inherit'}}>{article.title}</Link>
                </h2>
                <p style={metaStyle}>
                    Published on: {new Date(article.publication_date).toLocaleDateString()}
                    {article.author_email && ` by ${getAuthorDisplayName(article.author_email)}`}
                </p>
                {/* Use dangerouslySetInnerHTML to render HTML */}
                <div dangerouslySetInnerHTML={{ __html: excerpt }} />
                <Link to={`/blog/${article.slug}`} style={readMoreStyle}>Read More &raquo;</Link>
            </div>
        );
    }
}

export default class BlogListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            loading: true,
            error: null,
            // For pagination (to be implemented)
            // currentPage: 1,
            // totalPages: 1,
            // For filtering/sorting (to be implemented)
            // currentCategory: null,
            // currentTag: null,
            // currentSort: '-publication_date', 
        };
        this.loadArticles = this.loadArticles.bind(this);
    }

    componentDidMount() {
        this.fetchArticles();
    }

    // Method to fetch articles (can be extended for pagination, filtering, sorting)
    fetchArticles() { // Add params like page, filters, sortOrder later
        this.setState({ loading: true, error: null });
        // For now, fetch all public articles. Params for pagination etc. will be added.
        // e.g. /api/blog/public/articles/?page=1&ordering=-publication_date&categories__slug=tech
        ajax_wrapper('GET', '/api/blog/public/articles/', {}, this.loadArticles);
    }

    loadArticles(response) {
        if (response && response.results) { // Assuming pagination from DRF
            this.setState({
                articles: response.results,
                // totalPages: response.total_pages, // if paginated
                // currentPage: response.current_page, // if paginated
                loading: false
            });
        } else if (response && Array.isArray(response)) { // Non-paginated list
             this.setState({
                articles: response,
                loading: false
            });
        } else if (response && response.error) {
            this.setState({ error: response.error, loading: false });
        } else {
            this.setState({ error: 'Failed to load articles.', loading: false });
        }
    }

    render() {
        const { articles, loading, error } = this.state;

        const containerStyle = {
            maxWidth: '960px',
            margin: '0 auto',
            padding: '20px'
        };
        
        const loadingStyle = {
            textAlign: 'center',
            fontSize: '1.2em',
            padding: '50px'
        };

        const errorStyle = {
            color: 'red',
            textAlign: 'center',
            padding: '20px',
            border: '1px solid red',
            backgroundColor: '#ffeeee'
        };

        return (
            <div style={containerStyle}>
                <Helmet>
                    <title>Our Blog | YourHomeBase</title>
                    <meta name="description" content="Read the latest articles and insights from YourHomeBase on property taxes, home ownership, and more." />
                </Helmet>

                <h1>Blog</h1>

                {loading && <div style={loadingStyle}>Loading articles...</div>}
                {error && <div style={errorStyle}>Error: {error}</div>}

                {!loading && !error && articles.length === 0 && (
                    <p>No articles found.</p>
                )}

                {!loading && !error && articles.length > 0 && (
                    <div>
                        {articles.map(article => (
                            <BlogListItem key={article.slug} article={article} />
                        ))}
                    </div>
                )}

                {/* Pagination controls will go here */}
                {/* Filtering/Sorting controls will go here */}
            </div>
        );
    }
} 